import createDefaultConfig from './default'

const defaultConfig = createDefaultConfig(window.__initialState)

export default defaultConfig
